import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  IconButton,
  Avatar,
  HStack,
  VStack,
} from "@chakra-ui/react";
import {
  FaMicrophone,
  FaMicrophoneSlash,
  FaVolumeMute,
  FaVolumeUp,
} from "react-icons/fa";
import { MdCall, MdCallEnd } from "react-icons/md";
import { formatTimeSecondsToHHMMSS } from "../../logics/callLogic";
import { keyframes } from "@emotion/react";

const AudioCallModal = ({
  isOpen,
  callDirection,
  remoteUserName,
  callData,
  callDuration,
  // remoteUserMuted,
  isTalking,
  audioEnabled,
  toggleAudio,
  toggleSpeaker,
  isSpeakerOn,
  handleAnswerCall,
  handleEndCall,
  handleDeclineCall,
}) => {
  // for talking effect animation
  const pulseAnimation = keyframes`
      0% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.1); opacity: 0.7; }
      100% { transform: scale(1); opacity: 1; }
    `;

  return (
    <Modal closeOnOverlayClick={false} isOpen={isOpen} size="xs" isCentered>
      <ModalOverlay bg="blackAlpha.800" />
      <ModalContent bg="black" borderRadius="xl" color="white">
        <ModalHeader textAlign="center" fontSize="xs">
          {callDirection === "INCOMING" && "Incoming Call"}
          {callDirection === "OUTGOING" && "Outgoing Call"}
          {callDirection === "ONGOING" && "Ongoing Call"}
        </ModalHeader>
        <ModalBody pb={6}>
          <VStack spacing={6}>
            <Box
              position="relative"
              display="inline-block"
              animation={isTalking ? `${pulseAnimation} 1s infinite` : "none"}
              borderRadius="full"
              className={`talking-indicator ${isTalking ? "talking" : ""}`}
            >
              <Avatar size="xl" name={remoteUserName} />
            </Box>
            <Text fontSize="2xl" fontWeight="bold">
              {remoteUserName}
            </Text>
            {callDirection === "INCOMING" && (
              <>
                <Text fontSize="md" color="gray.600">
                  is calling...
                </Text>
                <HStack spacing={4}>
                  <Button
                    leftIcon={<MdCallEnd />}
                    aria-label="Decline Call"
                    colorScheme="red"
                    onClick={handleDeclineCall}
                  >
                    Decline
                  </Button>
                  <Button
                    leftIcon={<MdCall />}
                    aria-label="Accept Call"
                    colorScheme="green"
                    onClick={handleAnswerCall}
                  >
                    Accept
                  </Button>
                </HStack>
              </>
            )}
            {callDirection === "OUTGOING" && (
              <>
                <Text fontSize="md" color="gray.400">
                  {callData?.status === "RINGING" ? "Ringing..." : "Calling..."}
                </Text>
                <Button colorScheme="red" onClick={handleEndCall}>
                  Cancel
                </Button>
              </>
            )}
            {callDirection === "ONGOING" && (
              <>
                <Text fontSize="sm" color="gray.500">
                  {formatTimeSecondsToHHMMSS(callDuration)}
                </Text>
                <Button
                  leftIcon={<MdCallEnd />}
                  aria-label="End Call"
                  colorScheme="red"
                  onClick={handleEndCall}
                >
                  Hang Up
                </Button>
              </>
            )}
          </VStack>
        </ModalBody>
        {callDirection === "ONGOING" && (
          <ModalFooter justifyContent="center" flexDirection="column">
            <HStack spacing={6}>
              <IconButton
                aria-label="Toggle Audio"
                icon={audioEnabled ? <FaMicrophone /> : <FaMicrophoneSlash />}
                onClick={toggleAudio}
                variant="outline"
                color={audioEnabled ? "green.500" : "red.500"}
              />
              <IconButton
                aria-label="Toggle Speaker"
                icon={isSpeakerOn ? <FaVolumeUp /> : <FaVolumeMute />}
                onClick={toggleSpeaker}
                variant="outline"
                colorScheme={isSpeakerOn ? "green.500" : "red.500"}
              />
            </HStack>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default AudioCallModal;
